import React from 'react';
import './TourDatesStyles.css';
import TMLogo from '../assets/ticketmaster.png';

const TourDates = () => {
  return (
    <div className='worldtour'>
      <a href='https://www.ticketmaster.com/blackpink-tickets/artist/2590072'> <img src={TMLogo} className='ticketmaster' alt='ticketmaster website' /></a>
      <div className='img-container'>
              <ul>
              <br />
                <li>JULY 2, 2023, HYDE PARK</li>
                <br />
                <li>JULY 15, 2023, STADE DE FRANCE</li>
                <br />
                <li>AUGUST 11, 2023, METLIFE STADIUM</li>
                <br />
                <li>AUGUST 12, 2023, METLIFE STADIUM</li>
                <br />
                <li>AUGUST 18, 2023, ALLEGIANT STADIUM</li>
                <br />
                <li>AUGUST 22, 2023, ORACLE PARK</li>
                <br />
                <li>AUGUST 26, 2023, DODGER STADIUM</li>
                <br />
                <li>DECEMBER 1, 2023, BLACKPOOL OPERA HOUSE</li>
              </ul>
      </div>
    </div>
  )
}

export default TourDates;
